export default "__VITE_ASSET__CRFGIFPg__"